// Mai Shayi — keeps the custom header bag count in sync.
//
// Adding to cart is handled entirely by Horizon's own <product-form-component>,
// which dispatches shopify:cart:lines-update and opens the native cart drawer.
// This file adds no add-to-cart path of its own; it exists only because the Mai
// header is a custom section rather than Horizon's <header-actions>/<cart-icon>,
// so nothing else owns the "(N)" in the header.
//
// It reads the count from the event's own promise — the same source
// assets/cart-icon.js uses — so there is no extra cart request.
(() => {
  // the header section can re-execute this tag in the theme editor
  if (window.__msCartCountBound) return;
  window.__msCartCountBound = true;

  const CART_LINES_UPDATE = 'shopify:cart:lines-update';

  const render = (count) => {
    document.querySelectorAll('[data-ms-cart-count]').forEach((el) => {
      el.textContent = `(${count})`;
    });
  };

  document.addEventListener(CART_LINES_UPDATE, (event) => {
    event.promise
      ?.then(({ cart, detail }) => {
        const count = cart?.totalQuantity ?? detail?.itemCount;
        if (typeof count === 'number') render(count);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[mai-cart] cart event rejected:', error);
      });
  });

  // restore the right number when the page comes back from the bfcache
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } })
      .then((res) => (res.ok ? res.json() : null))
      .then((cart) => cart && render(cart.item_count))
      .catch(() => {});
  });
})();
